import { render, staticRenderFns } from "./AdminTab.vue?vue&type=template&id=102e5f04&"
import script from "./AdminTab.vue?vue&type=script&lang=ts&"
export * from "./AdminTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports